import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import lodash from 'lodash'
import VueLazyload from 'vue-lazyload'

import Api from '@/plugins/Api/index'
import DateFormat from '@/plugins/DateFormat/index'
import Flag from '@/components/Flag.vue'
import PinEditor from '@/components/PinEditor.vue'
import TagList from '@/components/TagList.vue'
import OrderStage from '@/components/OrderStage.vue'
import OrderUniconta from '@/components/OrderUniconta.vue'
import SvgIcon from '@/components/SvgFile.vue'
import Tabs from '@/components/Tabs.vue'
import TransactionHistory from '@/components/TransactionHistory.vue'
import OrderLink from '@/components/OrderLink.vue'
import CustomerLink from '@/components/CustomerLink.vue'
import StylistLink from '@/components/StylistLink.vue'
import UserLink from '@/components/UserLink.vue'
import OrderProductMatrix from '@/components/OrderProductMatrix.vue'
import ChargeOrder from '@/components/ChargeOrder.vue'
import OrderDiagnostics from '@/components/OrderDiagnostics.vue'
import Modal from '@/components/Modal.vue'
import OutfitModal from '@/components/OutfitModal.vue'
import Group from '@/components/Group.vue'
import Customer from '@/components/Customer.vue'
import EventViewer from '@/components/EventViewer.vue'
import EmailHistory from '@/components/EmailHistory.vue'
import OrderShippingEditor from '@/components/OrderShippingEditor.vue'
import CustomerSearch from '@/components/CustomerSearch.vue'
import DateTimePicker from '@/components/DateTimePicker.vue'
import Progress from '@/components/Progress.vue'
import UserSelector from '@/components/UserSelector.vue'
import QueuedTransaction from '@/components/QueuedTransaction.vue'
import Subscription from '@/components/Subscription.vue'

import MaterialText from '@/components/material/Text.vue'
import MaterialNumber from '@/components/material/Number.vue'
import MaterialDropdown from '@/components/material/Dropdown.vue'
import MaterialToggle from '@/components/material/Toggle.vue'
import Format from '@/components/Format.vue'
import Json from '@/components/Json.vue'
import Dropdown from '@/components/Dropdown.vue'
import DropdownItem from '@/components/DropdownItem.vue'
import DropdownSeparator from '@/components/DropdownSeparator.vue'
import Comments from '@/components/Comments.vue'
import ProductList from '@/components/ProductList.vue'
import OrderFileEditor from '@/components/OrderFileEditor.vue'
import ProductSearch from '@/components/ProductSearch.vue'
import CreditCard from '@/components/CreditCard.vue'
import OrderHistory from '@/components/OrderHistory.vue'
import CustomerOrders from '@/components/customer/CustomerOrders.vue'
import CustomEmailSender from '@/components/CustomEmailSender.vue'
import StylingViewModal from '@/components/StylingViewModal.vue'

import VueCookie from 'vue-cookie'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

Vue.use(VueCookie)

Vue.use(Api)
Vue.use(DateFormat)

Vue.use(VueLazyload, {
  preLoad: 1.3,
  // Use IntersectionObserver instead of the legacy throttled scroll handler.
  // The legacy mode only re-checks images on scroll/resize, so batches that mount
  // above the fold in a reactive render pass (e.g. the product/filter page on the
  // Styling Process page) could stay stuck on the loading GIF because no scroll ever
  // fired. IntersectionObserver observes each <img> independently of render timing.
  observer: true,
  observerOptions: {
    rootMargin: '200px',
    threshold: 0.1
  },
  error: 'https://i0.wp.com/teeqq.sfo2.digitaloceanspaces.com/2019/03/404-error-costume-not-found-funny-shirts-3.png?ssl=1&resize=510%2C510',
  loading: 'https://media.giphy.com/media/3oEjI6SIIHBdRxXI40/giphy.gif',
  attempt: 1
})

Vue.use(Loading, {
  loader: 'dots'
})

Vue.component('CustomEmailSender', CustomEmailSender)
Vue.component('CustomerOrders', CustomerOrders)
Vue.component('OrderHistory', OrderHistory)
Vue.component('CreditCard', CreditCard)
Vue.component('ProductSearch', ProductSearch)
Vue.component('OrderFileEditor', OrderFileEditor)
Vue.component('ProductList', ProductList)
Vue.component('Comments', Comments)
Vue.component('Dropdown', Dropdown)
Vue.component('DropdownItem', DropdownItem)
Vue.component('DropdownSeparator', DropdownSeparator)
Vue.component('QueuedTransaction', QueuedTransaction)
Vue.component('Json', Json)
Vue.component('Format', Format)
Vue.component('MaterialText', MaterialText)
Vue.component('MaterialNumber', MaterialNumber)
Vue.component('MaterialDropdown', MaterialDropdown)
Vue.component('MaterialToggle', MaterialToggle)

Vue.component('UserLink', UserLink)
Vue.component('UserSelector', UserSelector)
Vue.component('Progress', Progress)
Vue.component('CustomerSearch', CustomerSearch)
Vue.component('OrderShippingEditor', OrderShippingEditor)
Vue.component('EmailHistory', EmailHistory)
Vue.component('EventViewer', EventViewer)
Vue.component('Customer', Customer)
Vue.component('Group', Group)
Vue.component('Modal', Modal)
Vue.component('OutfitModal', OutfitModal)
Vue.component('OrderDiagnostics', OrderDiagnostics)
Vue.component('ChargeOrder', ChargeOrder)
Vue.component('OrderProductMatrix', OrderProductMatrix)
Vue.component('StylistLink', StylistLink)
Vue.component('CustomerLink', CustomerLink)
Vue.component('OrderLink', OrderLink)
Vue.component('TagList', TagList)
Vue.component('PinEditor', PinEditor)
Vue.component('Flag', Flag)
Vue.component('OrderStage', OrderStage)
Vue.component('OrderUniconta', OrderUniconta)
Vue.component('SvgIcon', SvgIcon)
Vue.component('Tabs', Tabs)
Vue.component('TransactionHistory', TransactionHistory)
Vue.component('DateTimePicker', DateTimePicker)
Vue.component('Subscription', Subscription)
Vue.component('StylingViewModal', StylingViewModal)

Vue.directive('click-outside', {
  bind: function (el, binding, vNode) {
    // Provided expression must evaluate to a function.
    if (typeof binding.value !== 'function') {
      const compName = vNode.context.name
      let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
      if (compName) { warn += `Found in component '${compName}'` }

      console.warn(warn)
    }
    // Define Handler and cache it on the element
    const bubble = binding.modifiers.bubble
    const handler = (e) => {
      if (bubble || (!el.contains(e.target) && el !== e.target)) {
        binding.value(e)
      }
    }
    el.__vueClickOutside__ = handler

    // add Event Listeners
    document.addEventListener('click', handler)
  },

  unbind: function (el, binding) {
    // Remove Event Listeners
    document.removeEventListener('click', el.__vueClickOutside__)
    el.__vueClickOutside__ = null
  }
})

Vue.filter('toCurrency', function (value) {
  if (typeof value === 'object') {
    if (value.currency === 'EUR') return '€ ' + value.regular_price
    else if (value.currency === 'DKK' || value.currency === 'SEK') return value.regular_price + ' kr.'
  } else {
    const currencyId = store.getters.userCurrencyId
    if (currencyId) {
      const format = store.state.repositories.locales.find(el => el.currency_id === currencyId).currency_representation
      return format.replace('*', value)
    }
    return value
  }
})

Vue.prototype._ = lodash

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
